<template>
  <div class="block py-24 sm:py-48" :class="{'w-full': inGrid}">
    <div class="container xxl:px-24">
      <div class="relative h-380 sm:460 md:h-620">
        <nuxt-img
          v-if="component.backgroundType == 'image'"
          :src="component.image"
          alt=""
          preset="standard"
          sizes="mob375:100vw mob390:100vw mob414:100vw desk:1324px"
          class="object-center object-cover absolute top-0 left-0 w-full h-full"
        />
        <video
          v-if="component.backgroundType == 'video'"
          class="absolute top-0 left-0 w-full h-full object-cover"
          autoplay
          muted
          loop
          playsinline
          :poster="component.image"
        >
          <source :src="component.video" type="video/mp4">
        </video>
        <div
          v-if="component.content"
          class="absolute left-1/2 top-1/2 transform -translate-y-1/2 -translate-x-1/2 w-full"
        >
          <div
            class="text-white px-24 sm:px-0 text-xl leading-md text-center font-medium sm:text-2xl sm:leading-lg md:text-3xl md:leading-xl sm:w-3/4 lg:w-1/2 mx-auto"
          >
            <div class="" v-html="component.content" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import ComponentBlock from '~/models/component-block';

import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    component: {
      type: ComponentBlock,
      required: true,
    },
    inGrid: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
});
</script>
